import { clsx } from 'clsx';
import type { ComponentPropsWithRef } from 'react';

export interface TextareaProps extends ComponentPropsWithRef<'textarea'> {
  /** Marks the control invalid (`aria-invalid` + error border). Pair it with `<FieldError>` via `aria-describedby`. */
  invalid?: boolean;
}

export function Textarea({ invalid, className, ...props }: TextareaProps) {
  return (
    <textarea className={clsx('field', className)} aria-invalid={invalid || undefined} {...props} />
  );
}
